

export enum AddUserType {
    TASK_USER       = 'TASK_USER',
    PROJECT_USER    = 'PROJECT_USER',
    WORKSPACE_USER  = 'WORKSPACE',
}